// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'apercuMonoRegularPro', 'apercuMonoRegularPro Fallback'"},"className":"__className_2cd762","variable":"__variable_2cd762"};